import * as React from 'react';

export interface SuccessIconProps {
  /**
   * Size of the success icon. default 48px
   */
  size?: number;
}

/**
 * Loading icon.
 */
export const SuccessIcon: React.FC<SuccessIconProps> = ({
  size = 48,
}: SuccessIconProps) => {
  return <img alt="" src="/assets/tick-full.png" height={size} width={size} />;
};

export default SuccessIcon;
